import type { Mapper } from './Mapper';

export abstract class MappingProfile {
  abstract configure(mapper: Mapper): void;
}
